
export type GetUserThreadsParams = {
page?: number;
size?: number;
/**
 * 검색어 (참여자 이름, 사용자명, 마지막 메시지)
 */
search?: string;
};
